import { useEffect } from "react";
import { shouldDefaultAcceptAllCookies } from "../../../custom-config/region.configs";
import { useCurrentRegion } from "~/lib/helpers/CurrencyHelper";
import { useCookieManager } from "~/lib/hooks/useCookieManager";
import CookieBanner from "./cookie-banner";
import CookieConsentManager from "./cookie-consent-manager";

export default function CookieSystem({ isMobile }: { isMobile: boolean }) {
  const regionConfig = useCurrentRegion();
  const {
    hasConsent,
    hasMadeDecision,
    showConsentManager,
    savePreferences,
    acceptAll,
    rejectAll,
    openConsentManager,
    closeConsentManager,
  } = useCookieManager();

  const autoAcceptAll = shouldDefaultAcceptAllCookies(regionConfig?.region);

  useEffect(() => {
    if (!autoAcceptAll || hasMadeDecision || hasConsent) return;
    acceptAll();
    // acceptAll is intentionally omitted — it is recreated each render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoAcceptAll, hasMadeDecision, hasConsent]);

  return (
    <>
      {!hasMadeDecision && !hasConsent && !autoAcceptAll && (
        <CookieBanner
          onCustomize={openConsentManager}
          onClose={closeConsentManager}
          onAcceptAll={acceptAll}
          onRejectAll={rejectAll}
          isMobile={isMobile}
        />
      )}

      <CookieConsentManager
        isOpen={showConsentManager}
        onClose={closeConsentManager}
        onSave={savePreferences}
      />
    </>
  );
}
